(function($) {
    $('.lightBox').magnificPopup({
    type:'image'
  });
})(jQuery);